export default __webpack_public_path__ + "static/media/personal-data.ded1bb89.svg";